module.exports = __webpack_public_path__ + "static/media/20-off-alt.27c59274.svg";